export enum PermissionGroup {
    MANAGE_BUSINESS = "manage_business",
    VIEW_CUSTOMERS = "view_customers",
    MANAGE_CUSTOMERS = "manage_customers",
    ALL_BUSINESS = "all_business",
    ALL_CUSTOMER = "all_customer",
    MANAGE_FINANCES = "manage_finances"
}
